import styled from "styled-components"
import { Main, OrnImg } from "../shared/StylePage"
import square from '../img/Redorn/square.png'
import rhomb from '../img/Redorn/rhomb.png'
import sunsign from '../img/Redorn/Vector (2).png'


const Text = styled.p`
    font-size: 24px;
    align-self: center;
    @media(width < 1440px){
        font-size: 22px;
    }
    @media(width <= 828px){
        font-size: 20px;
    }
`
const Orn = styled.div`
    margin-left: 37px;
    width: 164px;
    margin-right: 157px;
    height: 276px;
    @media(width < 1440px){
        margin-right: 100px;
    }
    @media(width < 1000px){
        margin-right: 0px;
    }
    @media(width <= 828px){
        display: none;
    }
`

export const ProjectInfo = () =>{
    return(
        <Main color="#FFFFFF" display='flex' padtop='57' id="s1">
            <Orn>
                <OrnImg src={rhomb} top='' left='' right='' bottom=''/>
                <OrnImg src={square} top='19' left='80' right='' bottom=''/>
                <OrnImg src={sunsign} top='150' left='' right='73' bottom=''/>
            </Orn>
            <Text>
                Форумы местных сообществ – это открытые площадки диалога и взаимодействия <br />
                муниципальных образований с некоммерческими организациями,органами  <br />
                государственной власти,предпринимателями,лидерами местных сообществ <br />
                для обмена мнениями,опытом,презентации эффективных практик и укрепления  <br />
                профессиональных контактов социальной сферы,в том числе в области <br />
                реализации государственной национальной политики.  
            </Text>
        </Main>
    )
}